import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumericValue } from 'utils/general';

import { TaskHeader } from '@/modules/home';
import { IHome } from '@/modules/home/types';
import { NextImage, Typography } from '@/shared/components/atoms';
import DemoCTA from '@/shared/components/atoms/Demo/Modals/DemoCTA';
import routes from '@/shared/constant/routes';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Map from '~/images/shared/map.svg';
import Clock from '~/images/shared/OtherClock.svg';

interface IProps {
  periodicTask: IHome.ITimelineOperationPeriodicItem;
}
const PeriodicTask = ({ periodicTask }: IProps): ReactElement => {
  const { t } = useTranslation();
  const { push } = useRouter();
  const { openModal } = useModal();
  const [store] = useStore((store) => store);
  const { isDemoFarm, asset } = store;

  return (
    <div
      onClick={() =>
        isDemoFarm
          ? openModal(<DemoCTA />)
          : push(`${routes.periodicJobs}/${periodicTask.id}`)
      }
      className='flex cursor-pointer gap-12 px-16'
    >
      <div className='shrink-0'>
        <div className='flex h-32 w-32 items-center justify-center rounded-full bg-blue-100'>
          <NextImage
            fill={false}
            src={periodicTask?.categoryIcon}
            alt={periodicTask.name}
            width={100}
            height={100}
            className='h-16 w-16'
          />
        </div>
      </div>
      <div className='flex flex-grow flex-col gap-12'>
        {/* task name and creator */}
        <TaskHeader
          createdBy={periodicTask.createdBy}
          name={`${periodicTask.name} ${t(
            periodicTask.status === 'done' ? 'over' : 'started'
          )}`}
          plots={periodicTask.plots}
          timestamp={periodicTask.updatedAt}
        />

        <div>
          <div className='inline-flex  w-full  items-center justify-between gap-3'>
            <div className='inline-flex  items-center  gap-3'>
              <Map />
              <Typography variant='subtitle2'>
                {t('total-working-area')}
              </Typography>
            </div>

            <Typography
              variant='caption'
              weight='bold'
              className='whitespace-nowrap'
            >
              {formatNumericValue(periodicTask.totalWorkingArea)}{' '}
              {t(asset?.areaUnit ?? 'acres')}
            </Typography>
          </div>
          <div className='inline-flex  w-full  items-center justify-between gap-3'>
            <div className='inline-flex  items-center  gap-3'>
              <Clock />
              <Typography variant='subtitle2'>
                {t('total-working-hours')}
              </Typography>
            </div>

            <Typography
              variant='caption'
              weight='bold'
              className='whitespace-nowrap'
            >
              {formatNumericValue(periodicTask.totalWorkingHours)} {t('hours')}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};
export { PeriodicTask };
